import React from 'react';
import { TextField, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { useFormContext } from 'react-hook-form';
import { incomeTooltip, monthlyIncomeOptions } from './constants';

const InputMonthlyIncome = () => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="monthlyIncome"
      control={control}
      rules={{ required: 'This field is required.' }}
    >
      <TextField
        select
        fullWidth
        label="Monthly Income"
        SelectProps={{
          native: true,
          sx: { p: 0 },
          endAdornment: (
            <Tooltip
              arrow
              title={incomeTooltip}
              placement="top"
              enterTouchDelay={0}
              sx={{ mr: 2, position: 'absolute', right: 15 }}
            >
              <HelpIcon color="info" />
            </Tooltip>
          ),
        }}
      >
        <option value="" disabled aria-label="blank option" />
        {monthlyIncomeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </TextField>
    </ValidatedTextField>
  );
};

export default InputMonthlyIncome;
